import React, { FunctionComponent } from 'react';

import { Translate } from 'react-localize-redux';

import CatalogFilter from '@common/types/catalog/catalog-filter-type';

import styled from 'styled-components';

// Components
import Flex from '@components/layout/flex';
import Typography from '@components/basics/typography';

import DateAddedFilter from './date-added';
import ReleaseDateFilter from './release-date';
import StatusFilter from './status';
import { ReleaseStatus } from '@common/types/release/relase-status';

const STATUS_FILTER: { label: string; value: ReleaseStatus }[] = [
  { label: 'Changes Needed', value: 'changes-needed' },
  { label: 'Pending Takedown', value: 'takedown-pending' },
  { label: 'Drafts', value: 'draft' },
  { label: 'Pending', value: 'pending' },
  { label: 'Approved', value: 'approved' },
  { label: 'Released', value: 'released' },
  { label: 'Rejected', value: 'rejected' },
  { label: 'Taken Down', value: 'taken-down' },
];

interface ReleasesCatalogMenuContentProps {
  className?: string;
  filterOption: CatalogFilter;
  setFilterOption: React.Dispatch<React.SetStateAction<CatalogFilter>>;
}

const ReleasesCatalogMenuContent: FunctionComponent<
  ReleasesCatalogMenuContentProps
> = ({ className, filterOption, setFilterOption }) => {
  const handleClearFilters = () => {
    setFilterOption({});
    return;
  };

  return (
    <Content className={className || ''}>
      <Header justifyContent="space-between" alignItems="center">
        <Typography weight="700">
          <Translate id="ANALYTICS.MENU.TITLE" />
        </Typography>
        <Typography className="clear-link" onClick={handleClearFilters}>
          <Translate id="ANALYTICS.MENU.CLEAR" />
        </Typography>
      </Header>
      <Separator />
      <div>
        <DateAddedFilter
          filterOption={filterOption}
          setFilterOption={setFilterOption}
        />
        <Separator />
        <ReleaseDateFilter
          filterOption={filterOption}
          setFilterOption={setFilterOption}
        />
        <Separator />
        <StatusFilter
          options={STATUS_FILTER}
          filterOption={filterOption}
          setFilterOption={setFilterOption}
        />
      </div>
    </Content>
  );
};

export default ReleasesCatalogMenuContent;

const Content = styled.div`
  height: 100%;
  overflow-x: hidden;
`;

const Header = styled(Flex)`
  margin-bottom: 30px;

  .clear-link {
    cursor: pointer;
    color: ${({ theme }) => theme.colors.tertiary};
    transition: color
      ${({ theme }) =>
        `${theme.transitions.duration} ${theme.transitions.type}`};

    &:hover {
      color: ${({ theme }) => theme.colors.accent};
    }
  }
`;

const Separator = styled.span`
  display: block;
  height: 1px;
  width: 100%;
  margin-block: 20px;
  background-color: ${({ theme }) => theme.colors.secondary};

  ${({ theme }) => `@media screen and ${theme.device.tablet}`} {
    width: calc(100% + 72px);
  }
`;
